import { getInvalidInterfacePaths } from './interfaceValidator';
export function missingVariable(variableName) {
    return new Error("Required parameter not provided: ".concat(variableName));
}
export function invalidParameter(variableName, errorMsg) {
    return new TypeError("Invalid parameter ".concat(variableName, ": ").concat(errorMsg));
}
export function invalidInterface(variableName, codec, invalidObject) {
    var configErrors = getInvalidInterfacePaths(codec.decode(invalidObject));
    var configErrorsWithPrefix = configErrors.map(function (error) { return "\n\t- ".concat(error); });
    var configErrorMsg = configErrorsWithPrefix.length !== 0 ? "Invalid keys:".concat(configErrorsWithPrefix.join('')) : '';
    return new TypeError("Invalid collection ".concat(variableName, ". ").concat(configErrorMsg));
}
//# sourceMappingURL=errorMessages.js.map